/* @flow */
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { Router, browserHistory } from 'react-router';
import { routeRenderer } from 'lib/Startup';

import routes from '../routes';
import store, { apolloClient } from 'reduxStore';

const Root = () => (
  <ApolloProvider store={store} client={apolloClient}>
    <Router
      routes={routes}
      history={browserHistory}
      render={routeRenderer}
    />
  </ApolloProvider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/main/Root.jsx